/**
 * Resolve an avatar image URL for an expert/analyst record from API or static seed data.
 * Returns same-origin `/api/...` paths so avatars load through the page host (dev.dash.minsky.ai, local proxy, etc.).
 */
export function resolveExpertAvatarUrl(expert) {
    if (!expert) return undefined;

    const raw =
        expert.profilePicture ||
        expert.photo ||
        expert.headshot ||
        expert.photoURL;

    if (raw) {
        if (raw.startsWith('http://') || raw.startsWith('https://')) {
            return raw;
        }
        if (raw.startsWith('/api/')) {
            return raw;
        }
        // Seed data uses /assets/*.jpg paths that are not shipped — prefer handle-based API avatar.
        if (raw.startsWith('/assets/') && expert.handle) {
            return `/api/experts/${encodeURIComponent(expert.handle)}/avatar`;
        }
        return raw;
    }

    if (expert.handle) {
        return `/api/experts/${encodeURIComponent(expert.handle)}/avatar`;
    }

    if (expert.hasAvatar === true) {
        const id = expert.externalId || expert.uid || expert.id || expert.userId;
        if (id) {
            return `/api/users/${encodeURIComponent(id)}/avatar`;
        }
    }

    return undefined;
}
